var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 71,
    viewBox: "0 0 74 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(-1367 -711)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_14",
    "data-name": "Elipse 14",
    cx: 37,
    cy: 35.5,
    rx: 37,
    ry: 35.5,
    transform: "translate(1367 711)",
    fill: "#3542c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone-in-talk",
    d: "M25.928,19.071a1.489,1.489,0,0,1,1.035.429,1.4,1.4,0,0,1,.464,1.071v5.357a1.595,1.595,0,0,1-1.5,1.5,25.494,25.494,0,0,1-13.035-3.464,25.587,25.587,0,0,1-9.428-9.428A25.494,25.494,0,0,1,0,1.5,1.434,1.434,0,0,1,.464.465,1.437,1.437,0,0,1,1.5,0H6.857A1.4,1.4,0,0,1,7.928.464,1.494,1.494,0,0,1,8.357,1.5a17.053,17.053,0,0,0,.857,5.428A1.461,1.461,0,0,1,8.857,8.5L5.5,11.857A22.408,22.408,0,0,0,15.572,21.928l3.357-3.357a1.461,1.461,0,0,1,1.572-.357,17.054,17.054,0,0,0,5.428.857Zm-1.572-5.357a10.262,10.262,0,0,0-3.107-7.536,10.261,10.261,0,0,0-7.535-3.107V0a13.225,13.225,0,0,1,9.714,4,13.225,13.225,0,0,1,4,9.714H24.357Zm-6.072,0a4.512,4.512,0,0,0-4.571-4.571V6.071a7.356,7.356,0,0,1,5.393,2.25,7.356,7.356,0,0,1,2.25,5.393H18.285Z",
    transform: "translate(1389.4 732.979)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFone);
export default __webpack_public_path__ + "static/media/fone.65126ca029063d68e2dd027c1854c838.svg";
export { ForwardRef as ReactComponent };